var _path, _path2, _rect, _rect2, _path3, _path4, _path5, _path6, _path7, _rect3, _rect4, _path8, _path9, _path10, _g, _path11, _rect5, _rect6, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 338,
    viewBox: "0 0 346 338",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.673 217.531C118.901 232.922 116.969 251.009 107.213 264.154C106.832 264.667 106.77 265.351 107.071 265.915C108.167 267.965 110.655 272.619 110.655 272.619L79.0981 289.382L76.3294 283.944C76.0342 283.364 75.4196 283.019 74.7681 283.046C58.3556 283.73 41.4403 274.062 33.2159 258.678C21.8174 237.356 29.9165 210.861 51.3057 199.498C72.6948 188.136 99.2745 196.209 110.673 217.531Z",
    fill: "#FB963D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8598 245.962C50.1281 241.856 50.6186 237.728 52.9511 236.748C55.2835 235.768 58.5915 238.309 60.3232 242.415C62.0548 246.521 61.5644 250.649 59.232 251.629C56.8995 252.609 53.5915 250.068 51.8598 245.962Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42.2079,
    height: 6.48883,
    rx: 3.24045,
    transform: "matrix(0.883583 -0.469384 0.471209 0.881431 76.9941 292.337)",
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 42.2079,
    height: 6.48883,
    rx: 3.24045,
    transform: "matrix(0.883583 -0.469384 0.471209 0.881431 80.8164 299.486)",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.063 288.348C120.167 290.414 120.853 292.676 121.08 295.005C121.307 297.335 121.072 299.686 120.387 301.925C119.703 304.164 118.583 306.246 117.091 308.054C115.599 309.861 113.765 311.358 111.693 312.458C109.621 313.559 107.352 314.242 105.015 314.469C102.678 314.695 100.319 314.461 98.0735 313.779C95.8276 313.096 93.7384 311.98 91.9253 310.493C90.1122 309.006 88.6107 307.177 87.5065 305.112L103.285 296.73L119.063 288.348Z",
    fill: "#ADADAD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2433 233.769C39.7967 231.748 41.0862 230.104 42.7814 229.503C44.4765 228.901 46.3141 230.54 46.7679 232.561C47.2218 234.582 46.1058 236.221 44.4106 236.822C42.7154 237.423 40.6971 235.79 40.2433 233.769Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7848 223.249C60.1394 221.327 57.4914 221.758 55.5544 223.393C53.6174 225.028 53.784 228.368 55.4241 230.299C57.0642 232.23 59.569 232.004 61.506 230.369C63.4431 228.734 63.425 225.18 61.7848 223.249Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4799 84.0644C36.9515 97.2469 41.5963 110.684 51.3113 119.033C51.7962 119.449 52.0131 120.102 51.8478 120.72C51.3509 122.576 50.3602 126.277 50.3602 126.277L77.5459 133.508L78.6387 129.071C78.7944 128.438 79.3149 127.964 79.9547 127.839C92.5623 125.362 103.682 114.987 107.208 101.812C112.125 83.4438 101.173 64.5802 82.7461 59.6793C64.3195 54.7784 45.3963 65.696 40.4799 84.0644Z",
    fill: "#F9E06A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6434 95.3852C91.235 91.9302 90.1199 88.8545 88.1569 88.5186C86.194 88.1827 84.1139 90.7184 83.5223 94.1734C82.9307 97.6284 84.0457 100.704 86.0087 101.04C87.9717 101.376 90.0518 98.8402 90.6434 95.3852Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 33.2319,
    height: 5.10279,
    rx: 2.5514,
    transform: "matrix(-0.966797 -0.257139 -0.258449 0.965601 79.6875 135.398)",
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 33.2319,
    height: 5.10279,
    rx: 2.5514,
    transform: "matrix(-0.966797 -0.257139 -0.258449 0.965601 78.0386 141.557)",
    fill: "#D9D9D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M46.733 139.828C46.2567 141.608 46.1367 143.463 46.3798 145.289C46.6229 147.114 47.2243 148.874 48.1498 150.468C49.0752 152.062 50.3065 153.459 51.7734 154.578C53.2403 155.698 54.9141 156.519 56.6991 156.993C58.4842 157.468 60.3455 157.588 62.1769 157.346C64.0084 157.103 65.774 156.504 67.3729 155.581C68.9719 154.659 70.373 153.431 71.4961 151.969C72.6192 150.507 73.4424 148.838 73.9187 147.059L60.3258 143.443L46.733 139.828Z",
    fill: "#ADADAD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3617 83.9735C97.342 82.3457 96.0594 81.3149 94.6526 81.1558C93.2458 80.9968 92.1311 82.5797 92.1453 84.2093C92.1594 85.8388 93.3081 86.8958 94.7149 87.0549C96.1217 87.2139 97.3758 85.603 97.3617 83.9735Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9695 79.7458C79.8863 77.9803 81.9928 77.8394 83.77 78.7476C85.5473 79.6559 86.0178 82.2449 85.1067 84.0165C84.1956 85.7882 82.2356 86.0609 80.4584 85.1526C78.6811 84.2444 78.0584 81.5175 78.9695 79.7458Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1076_18821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.565 147.09C296.788 180.034 272.388 205.075 242.034 213.34C241.072 213.602 240.337 214.382 240.165 215.363C239.437 219.516 237.595 230.02 237.595 230.02L170.314 218.295L172.629 206.494C172.824 205.498 172.401 204.486 171.572 203.901C145.857 185.762 131.646 151.244 137.422 118.311C145.394 72.852 188.825 42.4423 234.428 50.3893C280.031 58.3363 310.537 101.631 302.565 147.09Z",
    fill: "#FFD100"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M180.486 121.003C182.719 112.791 188.324 107.15 192.991 108.407C197.659 109.664 199.645 117.365 197.411 125.577C195.178 133.788 189.574 139.429 184.906 138.172C180.239 136.915 178.253 129.214 180.486 121.003Z",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 80.7118,
    height: 12.3804,
    rx: 5.0469,
    transform: "matrix(0.985153 0.171677 -0.172733 0.984969 163.663 220.28)",
    fill: "#D9D9D9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 80.7118,
    height: 12.3804,
    rx: 5.0469,
    transform: "matrix(0.985153 0.171677 -0.172733 0.984969 160.991 235.521)",
    fill: "#D9D9D9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M231.714 263.555C230.941 267.959 229.307 272.168 226.903 275.942C224.498 279.715 221.372 282.98 217.702 285.55C214.032 288.12 209.891 289.943 205.514 290.917C201.137 291.891 196.61 291.997 192.193 291.227C187.775 290.457 183.553 288.827 179.767 286.431C175.981 284.034 172.705 280.918 170.128 277.259C167.55 273.601 165.72 269.473 164.743 265.109C163.766 260.746 163.661 256.234 164.433 251.83L198.073 257.692L231.714 263.555Z",
    fill: "#ADADAD"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M177.369 89.0341C179.078 85.4687 182.959 84.5029 186.22 85.5834C189.481 86.664 190.316 91.2843 188.617 94.8591C186.918 98.434 183.306 99.5939 180.045 98.5134C176.783 97.4328 175.67 92.6089 177.369 89.0341Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M222.208 98.4285C221.996 93.6072 217.5 91.1544 212.656 91.3472C207.812 91.54 204.125 96.7641 204.319 101.593C204.512 106.422 208.55 109.016 213.394 108.823C218.239 108.631 222.401 103.257 222.208 98.4285Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1076_18821",
    x: 87.0431,
    y: 0.0274429,
    width: 265.888,
    height: 279.093,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.819608 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1076_18821"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1076_18821",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/Loading.856647e9153c7af5859469d6fcce42e0.svg";
export { ForwardRef as ReactComponent };